module.exports = __webpack_public_path__ + "static/media/exit-ic-red.611c8a0e.svg";